import tinycolor from "tinycolor2";

export function getContrastTextColor(bg: string): string {
  const tc = tinycolor(bg);
  return tc.isLight() ? "#000000" : "#FFFFFF";
}
